import type { ComponentType, SVGProps } from 'react';
import { Building, CubeBandage, DatabaseStar, LightBulbOn, Presentation, Tools } from 'iconoir-react';
import { BookOpen, Layers3 } from 'lucide-react';
import { cn } from 'lib/utils';
import type { ConfigureNavIconConfig } from 'constant/configure-nav';
import { CreateAgentIcon } from './icons/create-agent-icon';

const CONFIGURE_ICON_MAP = {
  CreateAgent: CreateAgentIcon,
  Layers3,
  CubeBandage,
  LightBulbOn,
  DatabaseStar,
  Tools,
  Presentation,
  BookOpen,
  Building,
} satisfies Record<Extract<ConfigureNavIconConfig, { type: 'iconoir' }>['name'], ComponentType<SVGProps<SVGSVGElement>>>;

interface ConfigureNavIconProps {
  icon: ConfigureNavIconConfig;
  size?: number;
  strokeWidth?: number;
  className?: string;
}

export function ConfigureNavIcon({
  icon,
  size = 20,
  strokeWidth = 1.75,
  className,
}: ConfigureNavIconProps) {
  const IconComponent = CONFIGURE_ICON_MAP[icon.name];

  return (
    <IconComponent
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={cn('shrink-0', className)}
      aria-hidden
    />
  );
}
